import React, { useState, useRef, useCallback } from "react";
import {
  defineBlock,
  useEditor,
  useToolbar,
  smartProps,
  useInspectorControl,
  useSmartProp,
} from "@smartfire/gutenberg-react";
import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import { ToolbarButton } from "@wordpress/components";
import YouTube from "react-youtube";
import { isMobile } from "react-device-detect";
import Modal from "../modalVideo/Modal.js";
import style from "./block.module.scss";
import Play from "../assets/play.svg";

import EditableText from "../shared/editable-text";

const ALLOWED_MEDIA_TYPES = ["image"];

function Inspector() {
  const [youtube_url, setYoutube_url] = useSmartProp("youtube_url");
  return (
    <>
      <PanelBody title="Configuration Vidéo" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"ID Vidéo Youtube"}
            value={youtube_url}
            onChange={(value) => setYoutube_url(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ background, youtube_url }) {
  useInspectorControl(Inspector);
  const [open, setOpen] = useState(false);
  const { isEditing, updateData } = useEditor();
  const ytRef = useRef();
  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      controls: 1,
      autoplay: 0,
      modestbranding: 1,
      playsinline: 0,
      rel: 0,
      showinfo: 0,
      fs: 1,
    },
  };
  const playerReady = useCallback(() => {
    if (ytRef.current) {
      const player = ytRef.current.internalPlayer;
      player.playVideo();
      if (isMobile) {
        player.getIframe().then((iframe) => {
          var requestFullScreen =
            iframe.requestFullScreen ||
            iframe.mozRequestFullScreen ||
            iframe.webkitRequestFullScreen;
          if (requestFullScreen) {
            requestFullScreen.bind(iframe)();
          }
        });
      }
    }
  }, [ytRef]);
  useToolbar(() => {
    return (
      <MediaUploadCheck>
        <MediaUpload
          onSelect={(image) => updateData({ background: image })}
          allowedTypes={ALLOWED_MEDIA_TYPES}
          value={background ? background.id : null}
          render={({ open }) => (
            <ToolbarButton
              onClick={open}
              icon="camera"
              label="Modifier l'image"
            />
          )}
        />
      </MediaUploadCheck>
    );
  }, [background, updateData]);
  return (
    <div
      className={style.block}
      style={{ backgroundImage: `url(${background.url})` }}
    >
      <div className={style.content}>
        <div className={style.titleBlock}>
          <EditableText
            className={style.title}
            placeholder={"Entrez un titre"}
            smartProp="title"
            tagName="h1"
          />
          {youtube_url && (
            <div className={style.playBlock}>
              <div className={style.bar} />
              <div className={style.play} onClick={() => setOpen(true)}>
                <img src={Play} alt="Play" />
                <EditableText
                  className={style.text}
                  placeholder={"Entrez un texte"}
                  smartProp="text"
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {youtube_url &&
        !isEditing && ( //Don't launch modal on admin
          <Modal open={open} handleClose={() => setOpen(false)}>
            <YouTube
              containerClassName={style.video}
              videoId={youtube_url}
              onReady={playerReady}
              onEnd={() => setOpen(false)}
              opts={opts}
              ref={ytRef}
            />
          </Modal>
        )}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    background: smartProps.any.withDefault(""),
    title: smartProps.string.withDefault(
      "L’innovation au coeur de vos projets logistiques et de conditionnement"
    ),
    youtube_url: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault("Lire la video"),
  },
  setup: {
    title: "Home Hero",
  },
});
